import React from 'react';
import { useIntl } from 'react-intl';
import { Col, Container, Row } from 'reactstrap';
import { faChartLineUp } from '@fortawesome/pro-solid-svg-icons/faChartLineUp';
import { faMegaphone } from '@fortawesome/pro-solid-svg-icons/faMegaphone';
import { faSackDollar } from '@fortawesome/pro-solid-svg-icons/faSackDollar';
import { SmartlinksMusicMarketingBox } from '../SmartlinksMusicMarketingBox';
import { nextAsset } from '../../../../components/nextAsset';

export const SmartlinksMarketingArtist: React.FC = () => {
  const intl = useIntl();

  return (
    <div className="smartlinks-music-marketing py-5">
      <Container className="py-5">
        <Row>
          <Col>
            <h2 className="main-header text-center pt-5 pb-3 text-secondary">
              {intl.formatMessage({
                id: 'sml.web.smartlinks.music-marketing-artist.title',
                defaultMessage: 'Break through the noise'
              })}
            </h2>
            <p className="main-header-subtitle text-center">
              {intl.formatMessage({
                id: 'sml.web.smartlinks.music-marketing-artist.drive-streams.title',
                defaultMessage:
                  'Route visitors to your most important content from an easy-to-navigate and impactful microsite.'
              })}
            </p>
          </Col>
        </Row>
        <Row className="align-items-stretch py-5">
          <SmartlinksMusicMarketingBox icon={faMegaphone}>
            {intl.formatMessage(
              {
                id: 'sml.web.smartlinks.artist.music-marketing.box1',
                defaultMessage: 'Capture people’s <b>attention</b> with beautiful landing pages'
              },
              {
                b: (str: React.ReactNode[]) => <strong className="text-uppercase text-secondary">{str}</strong>
              }
            )}
          </SmartlinksMusicMarketingBox>
          <SmartlinksMusicMarketingBox icon={faChartLineUp}>
            {intl.formatMessage(
              {
                id: 'sml.web.smartlinks.artist.music-marketing.box2',
                defaultMessage: 'Drive up your click-through <b>rates</b>'
              },
              {
                b: (str: React.ReactNode[]) => <strong className="text-uppercase text-secondary">{str}</strong>
              }
            )}
          </SmartlinksMusicMarketingBox>
          <SmartlinksMusicMarketingBox icon={faSackDollar}>
            {intl.formatMessage(
              {
                id: 'sml.web.smartlinks.artist.music-marketing.box3',
                defaultMessage: 'Convert visitors into fans and make <b>money</b>'
              },
              {
                b: (str: React.ReactNode[]) => <strong className="text-uppercase text-secondary">{str}</strong>
              }
            )}
          </SmartlinksMusicMarketingBox>
        </Row>
      </Container>
      <Container className="pt-5">
        <Row>
          <Col className="">
            <Container className="audience-container">
              <h2 className="main-header text-center pt-5 pb-3">
                {intl.formatMessage({
                  id: 'sml.web.smartlinks.artist.music-marketing.audience',
                  defaultMessage: 'Connect with your audience better than ever before'
                })}
              </h2>
              <p className="main-header-subtitle text-center pb-3">
                {intl.formatMessage({
                  id: 'sml.web.smartlinks.artist.music-marketing.audience.description',
                  defaultMessage:
                    'Allow fans to stream your music directly or redirect them to the streaming platform of their choice.'
                })}
              </p>
              <Row className="audience">
                <Col xs={12} md={6}>
                  <img
                    src={nextAsset('images/smartLinks/home/music-player.png')}
                    className="img-fluid"
                    alt="Music player"
                  />
                </Col>
                <Col md={1} />
                <Col xs={12} md={5} className="d-flex align-items-center">
                  <p className="header-subtitle text-body">
                    {intl.formatMessage(
                      {
                        id: 'sml.web.smartlinks.artist.music-marketing.audience.player',
                        defaultMessage: 'Embed a sleek <b>music player</b>'
                      },
                      {
                        b: (str: React.ReactNode[]) => <strong>{str}</strong>
                      }
                    )}
                  </p>
                </Col>
              </Row>
              <Row className="audience">
                <Col xs={12} md={6} className="d-flex align-items-center justify-content-center">
                  <Row>
                    <Col>
                      <img src={nextAsset('images/smartLinks/home/stats.png')} className="img-fluid" alt="Stats" />
                    </Col>
                  </Row>
                </Col>
                <Col md={1} />
                <Col xs={12} md={5} className="d-flex align-items-center justify-content-center">
                  <p className="header-subtitle text-body">
                    {intl.formatMessage(
                      {
                        id: 'sml.web.smartlinks.artist.music-marketing.audience.engagement',
                        defaultMessage:
                          '<b>Increase your engagement</b> and followers by ensuring they will be redirected to a relevant music app'
                      },
                      {
                        b: (str: React.ReactNode[]) => <strong>{str}</strong>
                      }
                    )}
                  </p>
                </Col>
              </Row>
              <Row className="audience p-4">
                <Col xs={12} md={6} className="d-flex align-items-center">
                  <img src={nextAsset('images/smartLinks/home/logos.png')} className="img-fluid" alt="Logo services" />
                </Col>
                <Col md={1} />
                <Col xs={12} md={5} className="d-flex align-items-center justify-content-center">
                  <p className="header-subtitle text-body">
                    {intl.formatMessage(
                      {
                        id: 'sml.web.smartlinks.artist.music-marketing.audience.streaming',
                        defaultMessage: 'Link fans to your music on <b>all major streaming platforms</b>'
                      },
                      {
                        b: (str: React.ReactNode[]) => <strong>{str}</strong>
                      }
                    )}
                  </p>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
